import { dateFormat, isNil, Nillable } from '@web/utils';

export const dateWithOffsetSerializer = () => {
  return (value: Nillable<Date>): string | null => {
    if (isNil(value)) {
      return null;
    }

    return dateFormat(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
  };
};
